func = {};

// Dev
//func.url_backend = "http://192.168.1.254:4000";

// Nodlight sur MINI PC
//func.url_backend = "http://localhost:3000";
//func.url_backend = "http://192.168.1.208:3000";

// Nodlight en PROD
func.url_backend = "https://v2.notifix.fr";

func.code_error = {
  "NON_TROUVE": "NON_TROUVE",
  "NON_ACTIF": "NON_ACTIF",
  "UTILISATEUR_EXISTANT": "UTILISATEUR_EXISTANT",
  "CONNEXION_ECHOUEE": "CONNEXION_ECHOUEE",
};

/*
* Parallax
*/
func.slider_full = function() {
  _headerHeight = 0, jQuery("#header").hasClass("transparent") || jQuery("#header").hasClass("translucent") ? _headerHeight = 0 : (_headerHeight = jQuery("#header").outerHeight() || 0, jQuery("#topBar").length > 0 && (_topBarHeight = jQuery("#topBar").outerHeight() || 0, _headerHeight += _topBarHeight)), _screenHeight = jQuery(window).height() - _headerHeight, jQuery("#header").hasClass("static") && (_screenHeight = jQuery(window).height()), jQuery("#slider").hasClass("halfheight") && jQuery("#slider.halfheight").css('min-height',_screenHeight / 2), jQuery("#slider").hasClass("thirdheight") && jQuery("#slider.thirdheight").css('min-height', _screenHeight / 1.5), jQuery("#slider").hasClass("fullheight") && (jQuery("#slider.fullheight").css('min-height',_screenHeight), jQuery("#slider.fullheight-min").css({
    "min-height": _screenHeight + "px"
  })), window.width < 960 && jQuery("#slider.mobile-fullheight").css('min-height', _screenHeight);
};

func.lightbox = function() {
  $('.lightbox').magnificPopup({
    type: 'image',
    removalDelay: 300,
    mainClass: 'mfp-with-fade',
  });
};


/*
* Menu
*/
func.topNav = function() {

  function t() {
    (n = jQuery(document).scrollTop()) > 100 ? jQuery("#toTop").is(":hidden") && jQuery("#toTop").show() : jQuery("#toTop").is(":visible") && jQuery("#toTop").hide()
  }

  function e() {
    jQuery("#sidepanel_overlay").unbind(), jQuery("#sidepanel_overlay").bind("click", function() {
      jQuery("a#sidepanel_btn").trigger("click")
    })
  }
  window.scrollTop = 0, window._cmScroll = 0;
  var i = jQuery("#header");
  jQuery(window).scroll(function() {
    t()
  });
  var a = false;

  if (jQuery("#topMain a.dropdown-toggle").bind("click", function(t) {
    "#" == jQuery(this).attr("href") && t.preventDefault(), a = jQuery(this).parent().hasClass("resp-active"), jQuery("#topMain").find(".resp-active").removeClass("resp-active"), a || jQuery(this).parents("li").addClass("resp-active")
  }), jQuery("li.search i.fa").click(function() {
    jQuery("#header .search-box").is(":visible") ? jQuery("#header .search-box").fadeOut(300) : (jQuery(".search-box").fadeIn(300), jQuery("#header .search-box form input").focus(), jQuery("#header li.quick-cart div.quick-cart-box").is(":visible") && jQuery("#header li.quick-cart div.quick-cart-box").fadeOut(300))
  }), 0 != jQuery("#header li.search i.fa").length && (jQuery("#header .search-box, #header li.search i.fa").on("click", function(t) {
    t.stopPropagation()
  }), jQuery("body").on("click", function() {
    jQuery("#header li.search .search-box").is(":visible") && jQuery("#header .search-box").fadeOut(300)
  })), jQuery(document).bind("click", function() {
    jQuery("#header li.search .search-box").is(":visible") && jQuery("#header .search-box").fadeOut(300)
  }), jQuery("#closeSearch").bind("click", function(t) {
    t.preventDefault(), jQuery("#header .search-box").fadeOut(300)
  }), jQuery("button#page-menu-mobile").bind("click", function() {
    jQuery(this).next("ul").slideToggle(150)
  }), jQuery("li.quick-cart>a").click(function(t) {
    t.preventDefault();
    var e = jQuery("li.quick-cart div.quick-cart-box");
    e.is(":visible") ? e.fadeOut(300) : (e.fadeIn(300), jQuery("li.search .search-box").is(":visible") && jQuery(".search-box").fadeOut(300))
  }), 0 != jQuery("li.quick-cart>a").length && (jQuery("li.quick-cart").on("click", function(t) {
    t.stopPropagation()
  }), jQuery("body").on("click", function() {
    jQuery("li.quick-cart div.quick-cart-box").is(":visible") && jQuery("li.quick-cart div.quick-cart-box").fadeOut(300)
  })), jQuery("#page-menu ul.menu-scrollTo>li").bind("click", function(t) {
    var e = jQuery("a", this).attr("href");
    jQuery("a", this).hasClass("external") || (t.preventDefault(), jQuery("#page-menu ul.menu-scrollTo>li").removeClass("active"), jQuery(this).addClass("active"), jQuery(e).length > 0 && (_padding_top = 0, jQuery("#header").hasClass("sticky") && (_padding_top = jQuery(e).css("padding-top"), _padding_top = _padding_top.replace("px", "")), jQuery("html,body").animate({
      scrollTop: jQuery(e).offset().top - _padding_top
    }, 800, "linear")))
  }), window.currentScroll = 0, jQuery("button.btn-mobile").bind("click", function(t) {
    t.preventDefault(), jQuery(this).toggleClass("btn-mobile-active"), jQuery("html").removeClass("noscroll"), jQuery("#menu-overlay").remove(), jQuery("#topNav div.nav-main-collapse").hide(0), jQuery(this).hasClass("btn-mobile-active") ? (jQuery("#topNav div.nav-main-collapse").show(0), jQuery("html").addClass("noscroll"),  window.currentScroll = jQuery(window).scrollTop()) : jQuery("html,body").animate({
      scrollTop: currentScroll
    }, 300, "linear")
  }), i.hasClass("bottom")) i.addClass("dropup"), window.homeHeight = jQuery(window).outerHeight() - 55, i.hasClass("sticky") && (window.isOnTop = true, jQuery(window).scroll(function() {
    jQuery(document).scrollTop() > window.homeHeight / 2 ? i.removeClass("dropup") : i.addClass("dropup")
  }), jQuery(window).scroll(function() {
    jQuery(document).scrollTop() > window.homeHeight ? true === window.isOnTop && (jQuery("#header").addClass("fixed"), i.removeClass("dropup"), window.isOnTop = false) : false === window.isOnTop && (jQuery("#header").removeClass("fixed"), i.addClass("dropup"), window.isOnTop = true)
  }), jQuery(window).resize(function() {
    window.homeHeight = jQuery(window).outerHeight()
  }));
  else if (i.hasClass("sticky")) {
    if (_topBar_H = jQuery("#topBar").outerHeight() || 0, window.width <= 992 && _topBar_H < 1) {
      n = jQuery(document).scrollTop();
      _header_H = i.outerHeight() || 0, i.addClass("fixed"), jQuery("body").css({
        "padding-top": _header_H + "px"
      })
    }
    jQuery(window).scroll(function() {
      if (window.width > 992 && _topBar_H < 1 || _topBar_H > 0) {
        var t = jQuery(document).scrollTop();
        t > _topBar_H ? (i.addClass("fixed"), _header_H = i.outerHeight() || 0, i.hasClass("transparent") || i.hasClass("translucent") || jQuery("body").css({
          "padding-top": _header_H + "px"
        })) : (i.hasClass("transparent") || i.hasClass("translucent") || jQuery("body").css({
          "padding-top": "0px"
        }), i.removeClass("fixed"))
      }
      if (i.hasClass("transparent")) {
        var e = jQuery("#topNav div.nav-main-collapse"),
        a = e.attr("data-switch-default") || "",
        n = e.attr("data-switch-scroll") || "";
        "" == a && "" == n || (t > 0 ? window._cmScroll < 1 && (e.removeClass(a, n).addClass(n), window._cmScroll = 1) : t < 1 && (e.removeClass(a, n).addClass(a), window._cmScroll = 0))
      }
    })
  } else if (i.hasClass("static") && i.hasClass("transparent")) {
    if (_topBar_H = jQuery("#topBar").outerHeight() || 0, window.width <= 992 && _topBar_H < 1) {
      var n = jQuery(document).scrollTop();
      _header_H = i.outerHeight() || 0, i.addClass("fixed")
    }
    jQuery(window).scroll(function() {
      (window.width > 992 && _topBar_H < 1 || _topBar_H > 0) && (jQuery(document).scrollTop() > _topBar_H ? (i.addClass("fixed"), _header_H = i.outerHeight() || 0) : i.removeClass("fixed"))
    })
  } else i.hasClass("static");
  if (jQuery("#slidetop a.slidetop-toggle").bind("click", function() {
    jQuery("#slidetop .container").slideToggle(150, function() {
      jQuery("#slidetop .container").is(":hidden") ? jQuery("#slidetop").removeClass("active") : jQuery("#slidetop").addClass("active")
    })
  }), jQuery(document).keyup(function(t) {
    27 == t.keyCode && jQuery("#slidetop").hasClass("active") && jQuery("#slidetop .container").slideToggle(150, function() {
      jQuery("#slidetop").removeClass("active")
    })
  }), jQuery("a#sidepanel_btn").bind("click", function(t) {
    t.preventDefault(), r = "right", jQuery("#sidepanel").hasClass("sidepanel-inverse") && (r = "left"), jQuery("#sidepanel").is(":hidden") ? (jQuery("body").append('<span id="sidepanel_overlay"></span>'), "left" == r ? jQuery("#sidepanel").stop().show().animate({
      left: "0px"
    }, 150) : jQuery("#sidepanel").stop().show().animate({
      right: "0px"
    }, 150)) : (jQuery("#sidepanel_overlay").remove(), "left" == r ? jQuery("#sidepanel").stop().animate({
      left: "-300px"
    }, 300) : jQuery("#sidepanel").stop().animate({
      right: "-300px"
    }, 300), setTimeout(function() {
      jQuery("#sidepanel").hide()
    }, 500)), e()
  }), jQuery("#sidepanel_close").bind("click", function(t) {
    t.preventDefault(), jQuery("a#sidepanel_btn").trigger("click")
  }), jQuery(document).keyup(function(t) {
    27 == t.keyCode && jQuery("#sidepanel").is(":visible") && jQuery("a#sidepanel_btn").trigger("click")
  }), jQuery("#menu_overlay_open").length > 0) {
    var o = !!jQuery("html").hasClass("ie9");
    1 == o && jQuery("#topMain").hide(), jQuery("#menu_overlay_open").bind("click", function(t) {
      t.preventDefault(), jQuery("body").addClass("show-menu"), 1 == o && jQuery("#topMain").show()
    }), jQuery("#menu_overlay_close").bind("click", function(t) {
      t.preventDefault(), jQuery("body").hasClass("show-menu") && jQuery("body").removeClass("show-menu"), 1 == o && jQuery("#topMain").hide()
    }), jQuery(document).keyup(function(t) {
      27 == t.keyCode && (jQuery("body").hasClass("show-menu") && jQuery("body").removeClass("show-menu"), 1 == o && jQuery("#topMain").hide())
    })
  }
  jQuery("#topBar").length > 0 && jQuery("#topNav ul").addClass("has-topBar"), jQuery(window).scroll(function() {
    window.width < 769 && (jQuery("#header li.quick-cart div.quick-cart-box").is(":visible") && jQuery("#header li.quick-cart div.quick-cart-box").fadeOut(0), jQuery("#header li.search .search-box").is(":visible") && jQuery("#header .search-box").fadeOut(0))
  })
},

func.wrotate = function() {
  jQuery(".word-rotator").each(function() {
    var t = jQuery(this),
    e = t.find(".items"),
    i = e.find("> span"),
    a = i.eq(0).clone(),
    n = jQuery(this).height(),
    o = 1,
    r = 0,
    s = jQuery(this).attr("data-delay") || 2e3;
    e.append(a), t.height(n).addClass("active"), setInterval(function() {
      r = o * n, e.animate({
        top: -r + "px"
      }, 300, "easeOutQuad", function() {
        ++o > i.length && (e.css("top", 0), o = 1)
      })
    }, s)
  });
  var t = jQuery("span.rotate");
  t.length > 0 && loadScript(plugin_path + "text-rotator/jquery.simple-text-rotator.min.js", function() {
    t.each(function() {
      var t = jQuery(this),
      e = t.attr("data-animation") || "fade",
      i = t.attr("data-speed") || 2e3;
      t.textrotator({
        animation: e,
        speed: parseInt(i)
      })
    })
  })
};


/*
* Configuration Google
*/
func.google = {
  map : {
    zoom: 9,
    center: {lng: 2.47809672, lat: 46.98716772 - 0.006},
    style: [
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#d3d3d3"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "color": "#808080"
          },
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#b3b3b3"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#ffffff"
          },
          {
            "weight": 1.8
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#d7d7d7"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#ebebeb"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#a7a7a7"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#efefef"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#696969"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#737373"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#d6d6d6"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {},
      {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      }
    ]
  }
};

module.exports = func;



// WEBPACK FOOTER //
// ./src/assets/js/fonctions.js